import { Time } from 'ohzi-core';
import { EasingFunctions } from 'ohzi-core';

import { Math as TMath } from 'three';
import { OS } from 'ohzi-core';

import WaitingForScroll from './WaitingForScroll';

export default class Transitioning
{
  constructor(target_wall)
  {
    this.target_wall = target_wall;
    this.target_z = OS.is_mobile ? target_wall.obj.position.z - 5 : target_wall.obj.position.z;
    this.t = 0;
  }

  on_enter(wall_clicker)
  {
    wall_clicker.camera_controller.set_idle();
    this.start_z = wall_clicker.camera_controller.reference_position.z;
    this.target_wall.is_opened = true;
  }

  update(wall_clicker)
  {
    this.t += Time.delta_time;
    let clamped_t = TMath.clamp(this.t, 0, 1);
    clamped_t = EasingFunctions.ease_in_out_cubic(clamped_t);

    wall_clicker.camera_controller.reference_position.z = TMath.lerp(this.start_z, this.target_z, clamped_t);
    this.target_wall.hover_t = clamped_t;

    if (this.t >= 1)
    {
      wall_clicker.set_state(new WaitingForScroll(this.target_wall));
    }
  }

  on_exit(wall_clicker)
  {
    wall_clicker.camera_controller.set_initial_mode(this.target_z, wall_clicker.walls_manager.hall_size);
  }
}
